import React, {useEffect, useRef, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Toast} from "primereact/toast";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {faCreditCard} from "@fortawesome/free-solid-svg-icons/faCreditCard";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import qs from "qs";
import {isBoolean} from "../../../../Utils/HelperFunctions";
import {updateGatewaySettings} from "../../../../Actions/MopriSettingActions";
import {FloatLabel} from "primereact/floatlabel";


const payFastStatuses = [{value: true, description: 'Active'}, {value: false, description: 'Inactive'}];
const payFastEnvironments = [{value: true, description: 'Sandbox Environment'}, {value: false, description: 'Live Environment'}];
const boolSelect = [{value: true, description: 'Yes'}, {value: false, description: 'No'}];

export const PayFastSettings= (props) =>  {
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const [payFastDetails, setPayFastDetails] = useState({
        payFastActive: false,
        payFastSandbox: false,
        payFastMerchId: '',
        payFastAPIKey: '',
        payFastMerchIdSandbox: '',
        payFastAPIKeySandbox: '',
        payFastPassphrase: '',
        payFastPassphraseSandbox: ''
    })
    const themeSettings = useSelector(state => state.theme);
    const gatewaySettings = useSelector(state => state.mopriSettings.gatewaySettings);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);
    const myToast = useRef(null)
    const dispatch = useDispatch();

    useEffect(() => {
        if (gatewaySettings) {
            setPayFastDetails({
                payFastActive: gatewaySettings.payFastActive ? isBoolean(gatewaySettings.payFastActive) : false,
                payFastSandbox: gatewaySettings.payFastSandbox ? isBoolean(gatewaySettings.payFastSandbox) : false,
                payFastMerchId: gatewaySettings.payFastMerchId,
                payFastAPIKey: gatewaySettings.payFastAPIKey,
                payFastMerchIdSandbox: gatewaySettings.payFastMerchIdSandbox,
                payFastAPIKeySandbox: gatewaySettings.payFastAPIKeySandbox,
                payFastPassphrase: gatewaySettings.payFastPassphrase,
                payFastPassphraseSandbox: gatewaySettings.payFastPassphraseSandbox,
            })
        }
    }, [gatewaySettings]);

    const handleOnChange = (e, field, type) => {
        if (type === 'dropdown') {
            setPayFastDetails({...payFastDetails, [field]: e.value});
        } else if (type === 'inputText') {
            setPayFastDetails({...payFastDetails, [field]: e.target.value});
        }
    }

    const updatePayFastSettings = () => {
        setSubmitButtonDisabled(true)
        axios({
            method: 'post',
            url: `${apiURL}/api/gateway/updatePayFast`,
            data: qs.stringify({
                ...payFastDetails
            }),
            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded' }}
        })
            .then((response) => {
                if (response && response.data.error) {
                    myToast.current.show({severity: 'error', summary: 'ERROR', detail: response.data.errorMessage, life: 5000});
                } else {
                    myToast.current.show({severity: 'success', summary: 'Success', detail: 'PayFast settings updated', life: 5000});
                    dispatch(updateGatewaySettings(payFastDetails))
                }
                setSubmitButtonDisabled(false)
            })
            .catch((e) => {
                setSubmitButtonDisabled(false)
                myToast.current.show({severity: 'error', summary: 'ERROR', detail: `An unexpected error took place`, life: 5000});
                console.log(e);
            });
    }

    return (
        <>
            <Toast ref={myToast} />
            <div className="p-fluid grid formgrid">
                <div className="field col-12">
                    <h4><FontAwesomeIcon icon={faCreditCard} style={{paddingRight: '10px'}}/> PayFast Settings</h4>
                </div>
            </div>

            <div className="p-fluid grid formgrid">
                <div className="field col-12">
                        <div className="p-fluid grid formgrid" >
                            <div className="field col-6">
                                <FloatLabel>
                                    <Dropdown value={payFastDetails.payFastActive}
                                              options={payFastStatuses} optionLabel="description"
                                              optionValue="value"
                                              onChange={(e) => handleOnChange(e, 'payFastActive', 'dropdown')}
                                    />
                                    <label htmlFor="payFastActive">PayFast Status</label>
                                </FloatLabel>
                            </div>
                            <div className="field col-6">
                                {payFastDetails.payFastActive &&
                                    <>
                                        <FloatLabel>
                                            <Dropdown value={payFastDetails.payFastSandbox}
                                                      options={payFastEnvironments} optionLabel="description"
                                                      optionValue="value"
                                                      onChange={(e) => handleOnChange(e, 'payFastSandbox', 'dropdown')}
                                            />
                                            <label htmlFor="payFastSandbox">PayFast Sandbox Test Environment</label>
                                        </FloatLabel>
                                    </>
                                }
                            </div>
                        </div>
                        {(payFastDetails.payFastActive && !payFastDetails?.payFastSandbox) &&
                            <>
                                <div className="p-fluid grid formgrid" >
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payFastDetails?.payFastMerchId}
                                                       onChange={(e) => handleOnChange(e, 'payFastMerchId', 'inputText')}
                                            />
                                            <label htmlFor="payFastMerchId">PayFast Merchant ID</label>
                                        </FloatLabel>
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payFastDetails?.payFastAPIKey}
                                                       onChange={(e) => handleOnChange(e, 'payFastAPIKey', 'inputText')}
                                            />
                                            <label htmlFor="payFastAPIKey">PayFast API Key</label>
                                        </FloatLabel>
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payFastDetails?.payFastPassphrase}
                                                       onChange={(e) => handleOnChange(e, 'payFastPassphrase', 'inputText')}
                                            />
                                            <label htmlFor="payFastPassphrase">PayFast Pass Phrase</label>
                                        </FloatLabel>
                                    </div>
                                </div>
                            </>
                        }
                        {(payFastDetails.payFastActive && payFastDetails?.payFastSandbox) &&
                            <>
                                <div className="p-fluid grid formgrid" >
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payFastDetails?.payFastMerchIdSandbox}
                                                       onChange={(e) => handleOnChange(e, 'payFastMerchIdSandbox', 'inputText')}
                                            />
                                            <label htmlFor="payFastMerchIdSandbox">PayFast Merchant ID (Sandbox)</label>
                                        </FloatLabel>
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payFastDetails?.payFastAPIKeySandbox}
                                                       onChange={(e) => handleOnChange(e, 'payFastAPIKeySandbox', 'inputText')}
                                            />
                                            <label htmlFor="payFastAPIKeySandbox">PayFast API Key (Sandbox)</label>
                                        </FloatLabel>
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <FloatLabel>
                                            <InputText value={payFastDetails?.payFastPassphraseSandbox}
                                                       onChange={(e) => handleOnChange(e, 'payFastPassphraseSandbox', 'inputText')}
                                            />
                                            <label htmlFor="payFastPassphraseSandbox">PayFast Pass Phrase (Sandbox)</label>
                                        </FloatLabel>
                                    </div>
                                </div>
                            </>
                        }

                        <div className="col-12">
                            <div className="p-fluid grid">
                                <div className="field col-12 md:col-9"></div>
                                <div className="field col-12 md:col-3">
                                    <Button label="Update PayFast Settings"
                                            severity="warning"
                                            disabled={submitButtonDisabled}
                                            style={themeSettings.buttonColor ? {background: `#${themeSettings.buttonColor}`} : {background: '#f97316'}}
                                            onClick={() => updatePayFastSettings()}
                                    />
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </>
    )
}